import { CommonModule, JsonPipe } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbDateParserFormatter, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { ToastService } from '../../Util/Toast/toast.service';
import { SupportTicketService } from '../../Model/Support/support-ticket.service';
import { CommonService } from '../../Model/Common/common.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { SessionService } from '../../Util/Session/session.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ViewSalarySlipComponent } from '../view-salary-slip/view-salary-slip.component';
import { AttendanceSummaryComponent } from '../attendance-summary/attendance-summary.component';

@Component({
  selector: 'app-salary-summary-details',
  standalone: true,
  imports: [NgbModule, FormsModule, NgSelectModule, CommonModule, LoaderComponent, JsonPipe, DataTablesModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './salary-summary-details.component.html',
  styleUrl: './salary-summary-details.component.scss'
})
export class SalarySummaryDetailsComponent {
  isDisabled: boolean = false;
  @Input() InputData: any;

  public User: any = null;

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective
  dtTrigger: Subject<any> = new Subject<any>();
  SalarySummary: any[] = []
  dtoptions: DataTables.Settings = {};
  constructor(public activeModal: NgbActiveModal,
    private toast: ToastService,
    private support: SupportTicketService,
    private modalService: NgbModal,
    protected common: CommonService,
    private tooltip: TooltipService,
    private sessionService: SessionService,
    private utility: UtilityService,
    private router: Router,
  ) {
    this.common.getPageRights();
    this.User = this.sessionService.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit() {
    this.getData();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  getData() {
    this.isDisabled = true;
    // this.SalarySummary = Object.values([]);
    // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //   dtInstance.destroy();
    //   this.dtTrigger.next(null);
    // });
    this.support.EmployeePayslipSummary({ SelectType: 'Summary', EmpMasterId: this.InputData.EmpMasterId }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.SalarySummary = Object.values(response.Table);
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
        return true
      },
      error: (err) => {
        this.isDisabled = false;
        return false;
      }
    })
  }
  Cancel() {
    this.activeModal.close();
  }

  ViewSalarySlip(element: any) {
    const modalRef = this.modalService.open(ViewSalarySlipComponent, { centered: true, backdrop: 'static', size: 'xl' });
    modalRef.componentInstance.InputData = {
      EmpMasterId: element.EmpMasterID,
      EmpName: element.EmpName,
      EmpCode: element.EmpCode,
      SiteName: element.SiteName,
      DesignationName: element.DesignationName,
      Photo: element.Photo,
      MonthYear: element.MonthYear,
      MonthAttendanceID : element.MonthAttendanceID,
      NormalDays : element.NormalDays,
      ClientGroupName : element.ClientGroupName,
      BranchName : element.BranchName
    };
    modalRef.result.then((result) => {
      if (result) {
        //window.location.reload();
      }
    }).catch((reason) => {
      console.log('Modal dismissed:', reason);
    });
  }

  ViewAttendance(element: any) {
    const modalRef = this.modalService.open(AttendanceSummaryComponent, { centered: true, backdrop: 'static', size: 'xl' });
    modalRef.componentInstance.InputData = {
      EmpMasterId: element.EmpMasterID,
      EmpName: element.EmpName,
      EmpCode: element.EmpCode,
      SiteName: element.SiteName,
      DesignationName: element.DesignationName,
      Photo: element.Photo,
      MonthYear: element.MonthYear
    };
    modalRef.result.then((result) => {
      if (result) {
        //window.location.reload();
      }
    }).catch((reason) => {
      console.log('Modal dismissed:', reason);
    });
  }
}
